// extracted by mini-css-extract-plugin
module.exports = {"pageWrap":"CommunityTopicPage_pageWrap__CMuWp"};